import script from "./briskDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./briskDetails.vue?vue&type=script&setup=true&lang=js"

import "./briskDetails.vue?vue&type=style&index=0&id=9aa24fd2&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aa24fd2"]])

export default __exports__